<template>
    <div class="h-100">
        <div class="loader-cont" v-dxloader="isLoader"></div>
        <div class="row h-100" v-show="!isLoader">
            <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
            <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
                <!-- Search for small screen-->
                <div class="container">
                    <div class="row">
                        <div class="col s10 m6 l6 alignLeft">
                            <h5 class="card-title alignLeft white-text">User Reviews</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col s12 p-0" style="height:calc(100% - 45px)">
                <div class="container p-0 h-100">
                    <div class="section p-0 h-100">
                        <div class="row m-0 h-100">
                            <div class="col s12 m12 l12 p-0 h-100">
                                <div id="responsive-table" class="card card card-default scrollspy p-0 h-100">
                                    <div class="card-content h-100" style="overflow:auto">
                                            <div class="search-input col s6">
                                                <div class="sidebar-search animate fadeUp">
                                                    <div class="search-area">
                                                    <i class="material-icons mr-2 search-icon">search</i>
                                                    <i class="material-icons mr-2 close-icon" v-show="filters.search"  @click="filters.search=''">close</i>
                                                    <input type="text" v-model="filters.search" placeholder="Search" class="app-filter" id="chat_filter">
                                                    </div>
                                                </div>
                                            </div>
                                        <div class="row" style="height: calc(100% - 85px);">
                                            <div class="col s12 packages h-100">
                                                <table class="responsive-table">
                                                    <thead>
                                                        <tr>
                                                            <th data-field="index">Booking ID</th>
                                                            <th data-field="id">User Name</th>
                                                            <th data-field="id">Vendor</th>
                                                            <th data-field="id">Review</th>
                                                            <th data-field="name">Rating</th>
                                                            <th data-field="date">Created At</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item) in reviewList.results" :key="item.id">
                                                            <td><a @click="goBookingDetail(item)" class="link-d">{{item.booking ? item.booking.uid : ""}}</a></td>
                                                            <td>{{item.user}}</td>
                                                            <td><a @click="$router.push({path: 'update-vendor/' + item.booking.vendor.id})" class="link-d">{{item.booking ? (item.booking.vendor ? item.booking.vendor.first_name : "") :""}}</a></td>
                                                            <td>{{item.review || 'N/A'}}</td>
                                                            <td><span class="star-rate">{{item.rating}} <i data-v-4286841d="" class="material-icons">star</i></span></td>
                                                            <td>{{item.created_at | date('D MMM YY, hh:mm a')}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    import jquery from "jquery";
    import validate from "jquery-validation";
    export default {
        data() {
            return {
                reviewList: {
                    count : 0,
                    previos : null,
                    next : null,
                    results : [],
                },
                filters : {
                    search : ""
                },
                isLoader : true,
            }
        },
        created() {
            this.isLoader = true;
            this.listReviews();
        },
        methods: {
            listReviews(url=Constants.default.APIURL.Reviews) {
                ajax.get(
                    url,
                    res => {
                        this.reviewList = res.data;
                        this.isLoader = false;
                        if(this.reviewList.results.length==0){
                            Vue.showNoDataBlock('.packages');
                        }else{
                            Vue.hideNoDataBlock('.packages');
                        }
                    },
                    err => {
                        this.isLoader = false;
                    }
                );
            },
            searchFilter(filter){
                let url = Constants.default.APIURL.Reviews + filter.search;
                // url += filter.search ? "?q=" + filter.search : "";
                this.listReviews(url);
            },
            goBookingDetail(booking){
                if(booking.booking.variant == "A"){
                    this.$router.push({path: 'audits-detail/' + booking.booking.uid})
                }else{
                    this.$router.push({path: 'booking-detail/' + booking.booking.uid})
                }
            }
        },
        watch: {
            filters: {
                handler: function() {
                    this.searchFilter(this.filters);
                },
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .add_btn {
        margin-top: 10px;
        margin-right: 10px;
    }

    .error-message{
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        text-align: right;
    }
    
    .margin-model {
        margin: 0px !important;
    }
    
    .dur_metric {
        text-align: left;
        display: flex;
        padding-top: 10px;
        justify-content: flex-start;
        align-content: center;
        input {
            width: auto !important;
            line-height: 0;
            height: 1.4rem;
            max-width: 50px;
            padding: 0 0 0 10px;
            box-shadow: none !important;
            margin: 0;
        }
        .inner-block {
            width: auto;
            margin-right: 20px;
            display: flex;
            align-items: center;
            span {
                display: inline-block;
                padding-right: 10px;
            }
        }
    }

    .btn-floating {
        color: #212121;
        background: white !important;
    }
    
    .btn-floating i {
        color: #212121;
    }
    a.add_btn{
        margin-top: 10px;
        margin-right: 10px;
        span{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }


    .link-d{
        cursor: pointer;
    }

    .star-rate{
        float: left;
    }
     .search-input {
        .sidebar-search {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        padding: 0 0 1rem 0;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -moz-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        }
        .search-area {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        width: -webkit-calc(100% - 0rem);
        width: -moz-calc(100% - 0rem);
        width: calc(100% - 0rem);
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        }
        i {
        font-size: 1.45rem;
        height: 41px;
        margin-right: 0 !important;
        padding: .75rem .25rem .35rem .75rem;
        color: #9e9e9e;
        border-radius: 5px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        background-color: #eceff1;
        }
        .app-filter {
        height: 35px;
        margin-bottom: 0;
        padding: .2rem;
        color: #9e9e9e;
        border: none;
        border-radius: 5px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        background-color: #eceff1;
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        border-bottom: 0 !important;
        box-shadow: none !important;
      }
    }
    .search-area{
        i.close-icon{
            position: absolute;
            right: 10px;
            cursor: pointer;
            font-size: 18px;
            top: 22px;
            height: inherit;
            padding: 0;
            line-height: 0;
        }
    }
</style>

